import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { EditComponent } from '@app/common/templates/edit/edit.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import { TblAnredeCreateComponent } from '@app/views/stammdaten/tbl_anrede/create/create.component';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
	templateUrl: '../../../../common/templates/edit/edit.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/edit/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblKundeEditComponent extends EditComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
	) {
		super(accountService, breadcrumbService, confirmationService, crudService, dialogService, globals, messageService, router, translate);

		this.apiUrl = 'TblKunde';
		this.name = 'MENU.KUNDE';
		this.url = '/kunde';
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung', required: false, width: 400 },
				{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400 },
				{ type: 'text', key: 'vorname1', required: true, width: 400 },
				{ type: 'text', key: 'nachname', required: true, width: 400 },
				{ type: 'object', key: 'anrede_id', required: false, width: 400, apiUrl: 'TblAnrede', createComponent: TblAnredeCreateComponent },
			],
			[
				{ type: 'text', key: 'strasse', required: false, width: 400 },
				{ type: 'numeric', key: 'hausnummer1', required: false, width: 400 },
				{ type: 'text', key: 'hauszusatz1', required: false, width: 400 },
				{ type: 'numeric', key: 'hausnummer2', required: false, width: 400 },
				{ type: 'text', key: 'hauszusatz2', required: false, width: 400 },
				{ type: 'plz', key: 'plz', required: false, width: 400 },
				{ type: 'village', key: 'ort', required: false, width: 400, plz_field: 'plz' },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.BHV' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.EDIT', routerLink: [this.url + '/' + PATH.EDIT + '/' + this.id] }
		]);
	}
}
